import { render } from "./ManualOrderItem.vue?vue&type=template&id=18cb630c&scoped=true"
import script from "./ManualOrderItem.vue?vue&type=script&lang=js"
export * from "./ManualOrderItem.vue?vue&type=script&lang=js"

import "./ManualOrderItem.vue?vue&type=style&index=0&id=18cb630c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18cb630c"]])

export default __exports__